import { http } from './client';
import type {
  WidgetConfigPatch,
  WidgetConfigView,
  WidgetHmacRotateResponse,
} from './types';

export const widgetApi = {
  async get(botId: string): Promise<WidgetConfigView> {
    const res = await http.get<WidgetConfigView>(
      `/v1/org/bots/${encodeURIComponent(botId)}/widget`,
    );
    return res.data;
  },
  async update(botId: string, patch: WidgetConfigPatch): Promise<WidgetConfigView> {
    const res = await http.put<WidgetConfigView>(
      `/v1/org/bots/${encodeURIComponent(botId)}/widget`,
      patch,
    );
    return res.data;
  },
  async rotateHmac(botId: string): Promise<WidgetHmacRotateResponse> {
    const res = await http.post<WidgetHmacRotateResponse>(
      `/v1/org/bots/${encodeURIComponent(botId)}/widget/rotate-hmac`,
    );
    return res.data;
  },
  async mintPreviewToken(
    botId: string,
    apiKey: string,
  ): Promise<{ token: string; expiresAt: number }> {
    const res = await http.post<{ token: string; expiresAt: number }>(
      `/v1/org/bots/${encodeURIComponent(botId)}/widget/preview-token`,
      { apiKey },
    );
    return res.data;
  },
  async revealHmacSecret(
    botId: string,
  ): Promise<{ hmacSecret: string | null; hmacSecretPrevious: string | null }> {
    const res = await http.get<{ hmacSecret: string | null; hmacSecretPrevious: string | null }>(
      `/v1/org/bots/${encodeURIComponent(botId)}/widget/hmac-secret`,
    );
    return res.data;
  },
};
